import React from "react";
import styled, { keyframes } from "styled-components";

import CustomModal from "components/customModal";
import ConfirmationPopup from "components/ConfirmationPopup";
import { useSessionExpiration } from "keycloak/useSessionExpiration";

const pulse = keyframes`
  0%, 100% { opacity: 1; transform: scale(1); }
  50%      { opacity: 0.72; transform: scale(1.06); }
`;

const CountdownHighlight = styled.span`
  color: #c50f3c;
  font-weight: bold;
  display: inline-block;
  min-width: 2.8ch;
  font-variant-numeric: tabular-nums;
  animation: ${pulse} 1s ease-in-out infinite;
`;

const WarningText = styled.span`
  color: #a61f3a;
  font-weight: 600;
`;

const SessionTimeoutModal = () => {
  const {
    showModal,
    countdown,
    isExpired,
    isLoading,
    handleContinue,
    handleLogin,
    handleLogout,
  } = useSessionExpiration();

  const bodyText = isExpired ? (
    <>
      <WarningText>Your session has expired.</WarningText> Please log in again
      to continue working.
    </>
  ) : (
    <>
      <WarningText>
        Your session is about to expire in{" "}
        <CountdownHighlight>{countdown} sec</CountdownHighlight>.
      </WarningText>{" "}
      Would you like to continue?
    </>
  );

  return (
    <CustomModal
      displayModal={showModal}
      hideModal={() => {}}
      size="sm"
      dilogClassName="alertModalSmall"
      backdrop="static"
      keyboard={false}
    >
      <ConfirmationPopup
        title="SESSION TIME OUT"
        text={bodyText}
        closeModal={handleLogout}
        handleConfirm={isExpired ? handleLogin : handleContinue}
        primaryButtonTitle={
          isExpired ? "LOGIN" : isLoading ? "LOADING..." : "CONTINUE"
        }
        secondaryButtonTitle={isExpired ? null : "LOG OUT"}
        isCancelNeeded={!isExpired}
      />
    </CustomModal>
  );
};

export default SessionTimeoutModal;
